import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-botones-cambios',
  templateUrl: './botones-cambios.component.html',
  styleUrls: ['./botones-cambios.component.scss']
})
export class BotonesCambiosComponent implements OnInit {

  constructor() { }

  @Input() mostrar: boolean;
  @Input() ocultarBotonSecundario: boolean;
  @Input() textoBotonPrincipal: string;

  @Output() onCancelar = new EventEmitter();
  @Output() onGuardar = new EventEmitter();

  ngOnInit() {
  }

  handleGuardar() {
    this.onGuardar.emit();
  }

  handleCancelar() {
    this.onCancelar.emit();
  }

}
